export default "__VITE_ASSET__oh6DWglX__"